import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import SchoolIcon from '@mui/icons-material/School';

export function getCategoryIcon(categoryId) {
  const icons = {
    1: <TrackChangesIcon className="!w-5 !h-5 text-blue-500" />,
    2: <TrendingUpIcon className="!w-5 !h-5 text-green-500" />,
    3: <SchoolIcon className="!w-5 !h-5 text-purple-500" />
  };
  
  const colors = ['text-blue-500', 'text-green-500', 'text-purple-500', 'text-amber-500', 'text-red-500', 'text-indigo-500'];
  const iconIndex = (categoryId - 1) % colors.length;
  const defaultIcon = <TrackChangesIcon className={`!w-5 !h-5 ${colors[iconIndex]}`} />;

  return icons[categoryId] || defaultIcon;
}

export function getCategoryColor(categoryId) {
  const colors = {
    1: 'border-l-blue-500 bg-blue-50/50',
    2: 'border-l-green-500 bg-green-50/50',
    3: 'border-l-purple-500 bg-purple-50/50'
  };
  
  const colorClasses = [
    'border-l-blue-500 bg-blue-50/50',
    'border-l-green-500 bg-green-50/50',
    'border-l-purple-500 bg-purple-50/50',
    'border-l-amber-500 bg-amber-50/50',
    'border-l-red-500 bg-red-50/50',
    'border-l-indigo-500 bg-indigo-50/50'
  ];
  const colorIndex = (categoryId - 1) % colorClasses.length;

  return colors[categoryId] || colorClasses[colorIndex];
}